import { useRef, useState } from 'react';
import { SelectElem } from '../../../common/select';
import {
  EXPENDITURE_BILL_OPTION_LIST,
  EXPENDITURE_DEPARTMENT_OPTION_LIST,
  EXPENDITURE_STATUS_OPTION_LIST,
  EXPENDITURE_TYPE_OPTION_LIST,
} from '../../../data/expenditure/constant';
import { SelectPreloadContainer } from '../../select-preload';
import { getAllUserList } from '../../../data/user/action';
import { convertUserListToSelect } from '../../../data/user/convert';
import { COLOR_ENUM } from '../../../theme/color';
import styled from 'styled-components';
import { FlexElem } from '../../../common/flex';
import { GridElem } from '../../../common/grid';
import { FieldDataTimeRangeElem } from '../../../common/field-datetime-range';
import { TextElem } from '../../../common/text';
import { Spacing } from '../../../theme';
import { ReactComponent as IndicatorIcon } from '../../../asset/svg/common/selectIndicator.svg';
import { ReactComponent as CloseIcon } from '../../../asset/svg/common/close.svg';
import { getProjectList } from '../../../data/project/action';
import { convertProjectListToSelect } from '../../../data/project/convert';
import { FieldTextElem } from '../../../common/field-text';
import { ButtonElem } from '../../../common/button';
import SearchIcon from '../../../asset/svg/button/search.svg';

import ClearIcon from '../../../asset/svg/common/close.svg';
export const FilterExpenditureList: React.FC<{
  filter: any;
  setFilter: any;
}> = ({ filter, setFilter }) => {
  const onChange = (name: any, e: any) => {
    console.log(name, e);
    if (!e) {
      setFilter({ ...filter, date: name.target.value });
    } else {
      setFilter({ ...filter, [name]: e });
    }
  };

  const handleCloseTimout = () => {
    setLocalSearch('');
    setFilter({ ...filter, search: '' });
  };
  const [localSearch, setLocalSearch] = useState('');
  const changeTimeout = useRef<any>(null);

  const handleChange = (e: { target: { name: string; value: string } }) => {
    clearTimeout(changeTimeout.current);
    setLocalSearch(e.target.value);

    changeTimeout.current = setTimeout(() => {
      console.log('handleChange');
      setFilter((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
    }, 500);
  };

  const [visible, setVisible] = useState(false);

  const handleOpen = () => {
    setVisible(true);
  };
  const handleClose = (e: any) => {
    e.stopPropagation();
    setVisible(false);
  };

  const multiValueContainer = ({ selectProps, data }: any) => {
    const label = data.label;
    const allSelected = selectProps.value;
    const index = allSelected.findIndex(
      (selected: any) => selected.label === label,
    );
    const isLastSelected = index === allSelected.length - 1;
    const labelSuffix = isLastSelected ? '' : ', ';
    const val = `${label}${labelSuffix}`;
    return val;
  };

  return (
    <Container spacing={4} onClick={handleOpen}>
      <TitleContainer>
        <TextElem tid="EXPENDITURE.FILTER.TITLE" color="textThird" />
        {visible ? <CloseIcon onClick={handleClose} /> : <IndicatorIcon />}
      </TitleContainer>
      {visible && (
        <FilterContainer style={{ flexWrap: 'wrap' }}>
          <SelectElem
            name="status"
            onChange={onChange}
            value={filter.status}
            options={EXPENDITURE_STATUS_OPTION_LIST}
            customComponents={{ MultiValueContainer: multiValueContainer }}
            isMulti
            placeholder="EXPENDITURE.FILTER.PLACEHOLDER.STATUS"
          />

          <SelectElem
            name="type"
            onChange={onChange}
            value={filter.type}
            options={EXPENDITURE_TYPE_OPTION_LIST}
            customComponents={{ MultiValueContainer: multiValueContainer }}
            isMulti
            placeholder="EXPENDITURE.FILTER.PLACEHOLDER.TYPE"
          />
          <SelectElem
            onChange={onChange}
            name="bill"
            options={EXPENDITURE_BILL_OPTION_LIST}
            value={filter.bill}
            customComponents={{ MultiValueContainer: multiValueContainer }}
            isMulti
            placeholder="EXPENDITURE.FILTER.PLACEHOLDER.BILL"
          />
          <FieldDataTimeRangeElem
            showTime={false}
            onChange={onChange}
            name={'date'}
          />

          <SelectCustom
            name="departmant"
            onChange={onChange}
            action={getProjectList}
            convert={convertProjectListToSelect}
            customComponents={{ MultiValueContainer: multiValueContainer }}
            value={filter.departmant}
            isMulti
            dynamic
            placeholder="EXPENDITURE.FILTER.PLACEHOLDER.DEPARTMENT"
          />
          <SelectCustom
            name="responsible"
            onChange={onChange}
            action={getAllUserList}
            convert={convertUserListToSelect}
            customComponents={{ MultiValueContainer: multiValueContainer }}
            value={filter.responsible}
            isMulti
            placeholder="EXPENDITURE.FILTER.PLACEHOLDER.RESPONSIBLE"
            dynamic
          />

          <SelectCustom
            name="executor"
            onChange={onChange}
            action={getAllUserList}
            convert={convertUserListToSelect}
            customComponents={{ MultiValueContainer: multiValueContainer }}
            value={filter.executor}
            isMulti
            placeholder="EXPENDITURE.FILTER.PLACEHOLDER.EXECUTER"
            dynamic
          />
          <SearchContainer>
            <FieldText
              name="search"
              onChange={handleChange}
              value={localSearch}
              placeholder="EXPENDITURE.FILTER.PLACEHOLDER.SEARCH"
            />
            {localSearch && (
              <Button
                iconLeft={ClearIcon}
                fill="clear"
                onClick={handleCloseTimout}
              />
            )}
          </SearchContainer>
        </FilterContainer>
      )}
    </Container>
  );
};

const FieldText = styled(FieldTextElem)`
  input {
    :focus-within {
      background: ${({ theme }) => theme[COLOR_ENUM.INPUT_BACKGROUND]};
    }

    :hover {
      background: ${({ theme }) =>
        theme[COLOR_ENUM.DEFAULT] === '#1B1924'
          ? theme[COLOR_ENUM.INPUT_BACKGROUND]
          : theme[COLOR_ENUM.INPUT]};
    }
    background: ${({ theme }) =>
      theme[COLOR_ENUM.DEFAULT] === '#1B1924'
        ? theme[COLOR_ENUM.INPUT_BACKGROUND]
        : theme[COLOR_ENUM.INPUT]};
    padding-left: ${Spacing(9)};
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-text-fill-color: ${({ theme }) => theme[COLOR_ENUM.TEXT_PRIMARY]};
    -webkit-box-shadow: 0 0 0px 1000px
      ${({ theme }) =>
        theme[COLOR_ENUM.DEFAULT] === '#1B1924'
          ? theme[COLOR_ENUM.INPUT_BACKGROUND]
          : theme[COLOR_ENUM.INPUT]}
      inset;
  }
  #content {
    width: 30px;
    height: 46px;
    position: absolute;
    top: 2px;
    left: 0;
    background: url(${SearchIcon}) no-repeat;
    background-position: top 40% left 12px;
    background-size: 16px;
  }
  width: 100%;
`;

const Container = styled(GridElem)`
  padding: ${Spacing(4)};
  border-radius: 10px;
  background-color: ${({ theme }) => theme[COLOR_ENUM.BACKGROUND_SECONDARY]};
  border: 1px solid ${({ theme }) => theme[COLOR_ENUM.BACKGROUND_PRIMARY]};
  cursor: pointer;
`;

const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

const Button = styled(ButtonElem)`
  position: absolute;
  --background: transparent;
  :hover {
    --background: transparent;
    border: none;
  }

  top: 14px;
  right: 16px;
  padding: 0;
`;

const TitleContainer = styled(FlexElem)`
  justify-content: space-between;
`;

const FilterContainer = styled(GridElem)`
  grid-template-columns: repeat(4, 1fr);
  @media screen and (width<950px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (width<550px) {
    grid-template-columns: 1fr;
  }
`;

const SelectCustom = styled(SelectPreloadContainer)`
  .Select__value-container--is-multi {
    display: flex;
    color: ${({ theme }) => theme[COLOR_ENUM.TEXT_SECONDARY]};

    width: 119px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .Select__value-container--has-value {
    display: block;
  }

  .Select__menu {
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }
  /* .Select__control {
    margin: auto;
    background: ${({ theme }) =>
    theme[COLOR_ENUM.DEFAULT] === '#1B1924'
      ? theme[COLOR_ENUM.INPUT_BACKGROUND]
      : theme[COLOR_ENUM.INPUT]};
  } */
`;
